import { Chip, SelectMenu, SelectMenuContent, SelectMenuItem, SelectMenuTriggerButton } from '@change/ds-core-ui';
import { CheckIcon, ExpandIcon, SortIcon } from '@change/ds-icons';

type SortSelectorProps = {
	currentRefinement: string;
	currentLabel: string;
	sortByTitle: string;
	options: ReadonlyArray<{ label: string; value: string; subtitle: string }>;
	// FIXME(SelectMenu): Using string | number because the component requires Key type from react-aria as value
	changeSelection: (value: string | number | null) => void;
};

export const DesktopSortSelector: React.FC<SortSelectorProps> = ({
	sortByTitle,
	currentRefinement,
	currentLabel,
	options,
	changeSelection,
}) => {
	return (
		<SelectMenu
			// SelectMenu is uncontrolled (only defaultSelectedId, no controlled selectedId), so its
			// internal selection sticks after an external reset (e.g. "Clear filters"). Keying on
			// currentRefinement remounts it so the default re-seeds and the selection stays in sync.
			key={currentRefinement || 'default'}
			ariaLabel={sortByTitle}
			defaultSelectedId={currentRefinement}
			onSelectionChange={changeSelection}
			data-testid="sort-selector"
			data-qa="sort-selectMenu"
		>
			<SelectMenuTriggerButton>
				{() => (
					<Chip leadingIcon={<SortIcon />} trailingIcon={<ExpandIcon />} forceInteractive>
						{sortByTitle} {currentLabel}
					</Chip>
				)}
			</SelectMenuTriggerButton>
			<SelectMenuContent className="max-h-96 max-w-96">
				{options.map((option) => (
					<SelectMenuItem
						key={option.value}
						value={option.value}
						label={option.label}
						trailingIcon={currentRefinement === option.value ? <CheckIcon /> : undefined}
						body={option.subtitle}
					/>
				))}
			</SelectMenuContent>
		</SelectMenu>
	);
};
